const MODULE_URL = 'favorite_directories';
export default {
  MODULE_URL: MODULE_URL,

  GROUPED_DIRECTORIES_URL: MODULE_URL + '/grouped_paths',
  DIRECTORIES_URL: MODULE_URL,

  DIRECTORIES_UPDATED: 'favorite_directories_updated',
};
